import React, { useState } from "react";
import Alert from "../../../controls/Alert";
import {validateEmail} from "../../../functions/EmailValidation";
import validatePasswordRules from "../../../functions/PasswordValidation";

const CompanyUserValidator = (props) => {
  const record = props.record;

  const [state, setState] = useState({
    error: null,
    errorMessage: null
  });

  let error = false;
  let errorMessage = "";
  let id = null;

  /*
    Examples of validators - the record will have a copy of the working data
  */
  // if (!record.*code*) {
  //   error = true;
  //   errorMessage = "Please select a valid code";
  // } else if (!moment(record.*date*).isValid()) {
  //   error = true;
  //   errorMessage = "Please enter a valid date";
  // } else if (moment(record.*date1*).isBefore(record.*date2*)) {
  //   error = true;
  //   errorMessage = "The '*date1 name*' date cannot be before the '*date2 name' date";
  // } else if (record.*number* <= 0) {
  //   error = true;
  //   errorMessage = "The *number field* must be greater than zero";
  // }


  if (!error && !record.firstName) {
    error = true;
    errorMessage = "'First Name' is required";
    id = "firstName";
  }
  if (!error && !record.lastName) {
    error = true;
    errorMessage = "'Last Name' is required";
    id = "lastName";
  }
  if (!error && !record.email) {
    error = true;
    errorMessage = "'User Email' is required";
    id = "name";
  }
  if (!error && record.email && !validateEmail(record.email)) {
    error = true;
    errorMessage = "Please enter a valid email address for 'User Email'";
    id = "name";
  }
  if (!error && !record.department) {
    error = true;
    errorMessage = "'Department' is required";
    id = "department";
  }

  if (record.newUser) {
    if (!error && !record.password) {
      error = true;
      errorMessage = "'Password' is required";
      id = "password";
    }
    if(!error && record.password) {
      const password = {value: record.password};
      const passwordResponse = validatePasswordRules("Dummy current password", password, password);
      if (!passwordResponse.valid) {
        error = true;
        errorMessage = passwordResponse.errorText;
        id = "password";
      }
    }
    if (!error && !record.repeatPassword) {
      error = true;
      errorMessage = "'Repeat Password' is required";
      id = "repeatPassword";
    }
    if (!error && record.password && record.repeatPassword && record.password !== record.repeatPassword) {
      error = true;
      errorMessage = "Password and Repeat Password do not match";
      id = "repeatPassword";
    }
    if (!error && record.roles && Array.isArray(record.roles) && record.roles.length === 0) {
      error = true;
      errorMessage = "At least one Role is required";
      id = "roles";
    }
  }

  if (error !== state.error || errorMessage !== state.errorMessage) {
    setState({ ...state, error, errorMessage });
    if (props.onChange) {
      props.onChange({ error, errorMessage });
    }
  }

  return (
    <Alert open={error} severity="error" message={errorMessage} id={id}/>
  );
}

export default CompanyUserValidator;
